import { render } from "./CollectionProtocols.vue?vue&type=template&id=7b33cfb3"
import script from "./CollectionProtocols.vue?vue&type=script&lang=js"
export * from "./CollectionProtocols.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__